import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { UatNav } from "../Navbar/UatNav";
import OnboardStep from "./OnboardStep";
import { ChangePassWord } from "./ChangePass";
import { PospProfile } from "./ProfilePosp";

const { TabPane } = Tabs;

const ProfileTab = ({ setOpen }) => {
  const [TabKeys, setTabKey] = useState("1");

  const onChange = (key) => {
    console.log(key);
    setTabKey(key);
  };

  // useEffect(() => {
  //   const pathname = window.location.pathname;
  //   console.log("Pathname:", pathname);

  //   if (pathname === '/ProfileView') {
  //     console.log('ssssss3');
  //     setTabKey("3");
  //   } else {
  //     setTabKey("2");
  //   }
  // }, []);

  return (
    <>
      {/* <UatNav /> */}
      <div
        className="h-100"
        style={{ padding: "20px 0px", background: "#e9f4ff" }}
      >
        <Tabs
          onChange={onChange}
          type="card"
          className="container ONB-Tabs"
          activeKey={TabKeys}
        >
          <TabPane tab="Profile" key="1">
            <p className="mb-0 cp-txt">Profile Details</p>
            <PospProfile />
          </TabPane>
          <TabPane tab="Change Password" key="2">
            <p className="mb-0 cp-txt">Change Password</p>
            <ChangePassWord setOpen={setOpen} />
          </TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default ProfileTab;
